<template>
   <div class="asset-container" :class="{active: isActive}">
      <div class="thumbnail-container" @click="handleClickAsset" :class="{selected: isSelected}">
         <div v-if="isInstance" class="drag" :transfer-data="{asset, currSelectedAssetType, imgSrc: './../../assets/img/instances-graphic.svg'}">
         </div>

         <div v-if="currSelectedAssetType === 6">
            <img v-if="asset.c_uri == null || asset.c_uri === ''"  class="media-picker-img" src="./../../assets/img/media/bttn_library_feeds_off.svg">
            <img v-else class="media-picker-img" v-bind:src="this.GALLERY_HOST + '/' + asset.c_uri">
         </div>

         <div v-else>
            <span v-if="asset.c_uri == null || asset.c_uri === ''" class="media-picker-img" ></span>
            <!-- <img v-else class="media-picker-img" 
                  :class="{is_dragging: draggingAssetRecid == asset.recid}"
                  draggable="true" 
                  @dragstart="drag" 
                  @dragend="dragEnd"
                  v-bind:src="this.GALLERY_HOST + '/' + asset.c_uri"> -->
            <img v-else class="media-picker-img" 
               v-bind:src="this.GALLERY_HOST + '/' + asset.c_uri">
         </div>
      </div>

      <div class="btn-info-container">
         <button class="btn-info" v-click-outside="hide" @keyup.esc="hide" @click.self="toggleShowmeta(), toggleInfoSelected()" :class="{ selected: infoIsSelected }"><span>Show Meta Data</span></button>
      </div>
      <transition name="meta-data-transition">
         <div class="meta-data-container" v-if="showMetadata">
            
             <m-p-meta-data
               :assetRecid="asset.recid">
            </m-p-meta-data>

         </div>
      </transition>
   </div>
</template>

<script> 
// import { EventBus } from './../../event-bus.js';
import MPMetaData from './MPMetaData';

import { mapActions, mapState } from 'vuex';

export default {
   data() {
      return {
         showMetadata: false,
         infoIsSelected: false,
      }
   },

   props: {
      asset: Object, 
      assetType: String | Number,
      index: Number //index in the list of assets
   },

   methods: {
      ...mapActions('global', 
         [
            'draggingAsset',
            'stopDraggingAsset',
            'addSelectedAsset',
            'assignAsset'
         ]
      ),

      drag(e) {
         //todo: do not need to pass currSelectedAssetType
         e.preventDefault();
         this.draggingAsset({assetRecid: this.asset.recid, assetType: this.currSelectedAssetType});
      },

      dragEnd(e) {
         // e.preventDefault();
         this.stopDraggingAsset({});
      },

      handleClickAsset() {
         // if (this.mpMultiSelect) {
         //    this.addSelectedAsset({assetRecid: this.asset.recid});
         // } else {
         //    this.assignAsset({asset: this.asset});
         // }
         this.assignAsset({asset: this.asset});
      },

      // assignAsset() {
      //    //caught by the Smart Canvas, assigns the asset to the active zone
      //    EventBus.$emit('assign-asset', this.asset, this.currSelectedAssetType);
      // },
      toggleShowmeta: function() {
         this.showMetadata = !this.showMetadata
      },
      toggleInfoSelected: function() {
         this.infoIsSelected = !this.infoIsSelected
      },
      hide: function() {
         this.showMetadata = false;
         this.infoIsSelected = false;
      },

      toggleSound: function() {
         const mediaElem = document.querySelectorAll('.audio')[this.index];
         if (!this.isPlaying) {
            this.$emit('play', this.index);
         } else {
            this.$emit('pause', this.index);
         }
      },

      convertDuration(duration) {
         let minutes = Math.floor(duration / 60);
         let seconds = duration - minutes * 60;
         if (seconds === 0) {
            seconds = '00';
         } else if (seconds < 10) {
            seconds = '0' + seconds;
         }
         return minutes + ':' + seconds;
      }
   },

   computed: {
      ...mapState('global',
         [
            'draggingAssetRecid',
            'selectedAssets',
            
            'currSelectedAssetType',
            'mpCurrActiveAssetRecid',
            'mpMultiSelect'
         ]
      ),
      
      isInstance() {
         return this.currSelectedAssetType === 'instances';
      },

      isPlaying() {
         return this.index == this.playingIndex;
      },

      isSelected() {
         return this.selectedAssets.includes(this.asset.recid);
      },

      isActive() {
         return this.asset.recid == this.mpCurrActiveAssetRecid;
      }
   },

   components: {
      MPMetaData
   }
}
</script>

<style lang="scss" scoped>
.media-picker-img {
   max-width: 68px;
   max-height: 68px;
   -webkit-transform: perspective(1px) translateZ(0);
   transform: perspective(1px) translateZ(0);
   -webkit-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -webkit-transition-property: transform;
   transition-property: transform;

   &:hover {
      cursor: pointer;
      // border: 1px solid $bard-gold;
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
   }

   &.is_dragging {
      pointer-events: none;
   }
}

.media-picker-img-text {
   font-size: 8px;
   overflow: hidden;
   white-space: nowrap;
   width: 82px;
   text-overflow: ellipsis;
   color: white;
}

.btn-info-container {
   width: 1.125rem;
   height: 1.125rem;
   padding: 2px;

   .btn-info {
      width: 1rem;
      height: 1rem;
      padding: 0;
      border: 0;
      background-image: url('./../../assets/img/info-circle-solid.svg');
      background-color: transparent;
      background-size: 1rem 1rem;
      background-position: 0 0;

      &:hover,
      &.selected {
         background-image: url('./../../assets/img/info-circle-solid-on.svg');
         background-color: transparent;
         cursor: pointer;
         outline: none;
      }

      &:focus {
         outline: 1px solid #3bca43;
         box-shadow: none;
         outline: none;
      }
  }
}
.meta-data-container {
   position: absolute;
   width: 205px;
   
   padding: 18px;
   z-index: 2;
   background-color: white;
   // box-shadow: -10px -10px 20px rgba(0,0,0,0.8);
   text-align: center;

   .btn-media-lib {
      margin-top: 2em;
      padding: 4px 20px;
      background: #1f2532;
      border: 0; 
      text-align: center;
      text-transform: uppercase;
      font-size: .65rem;
      color: #3bca43;
   }
}
.meta-data-transition-enter,
.meta-data-transition-leave-to  {
  transform: rotateY(90deg);
}
.meta-data-transition-enter-active,
.meta-data-transition-leave-active{
  transition: transform 300ms ease-in;
}
.meta-data-transition-enter-to,
.meta-data-transition-leave {
  transform: rotateY(0deg);
}

.asset-container, 
.mp-asset-container {
   button {
      border: 0;
      background-color: initial;
      color: white;
      cursor: pointer;
      
      span {
         position: absolute;
         left: -10000px;
         top: auto;
         width: 1px;
         height: 1px;
         overflow: hidden;
      }
   }
}
// Container for all assets, except audio 
.asset-container {
   position: relative;
   text-align: center;

   &:not(:last-child) {
      margin-right: 10px;
   }

   .meta-data-container {
      top: 1%;
      left: 96%;
   }

   &:nth-of-type(3n),
   &:nth-of-type(4n) {
      .meta-data-container {
         left: initial;
         right: 34%;
      }
   }

   .thumbnail-container {
      margin: 0 4px;
      color: white;
      width: 68px;
      height: 68px;
      background: black;
      border: 1px solid #313d50;
      overflow: hidden;

      display:flex;
      justify-content: center;
      align-items: center;

      &.selected {
         border: 4px solid $bard-gold;
      }
   }

   // .media-picker-img {
   //    width: 68px;
   //    height: 68px;
   //    border: 1px solid #313d50;

   //    &:hover {
   //       cursor: pointer;
   //    }
   // }

   .media-picker-feed {
      width: 50px; 
      height: 65px;
      border: 0;

      &:hover,
      &:focus {
         cursor: pointer;
      }

      &:focus {
         outline: 0;
      }
   }

   .media-picker-img-text {
      font-size: 8px;
      overflow: hidden;
      white-space: nowrap;
      width: 82px;
      text-overflow: ellipsis;
      color: white;
   }

   .btn-info-container {
      position: absolute;
      bottom: 6px;
      right: 8px;
   }

   &.active {

      .thumbnail-container {
         border: 1px solid $bard-green;
      }
   }
}

// Container for audio and weblink assets only
.mp-asset-container {
   position: relative;
   width: 100%;
   flex: 1 0 auto;
   padding: 0;
   border: 1px solid transparent;
   border-bottom-color: #666;
   text-align: left;

   &:hover {
      border: 1px solid $bard-green;
      cursor: pointer;
   }

   &.active {
      background-color: #507a2b;
   }
   .mp-asset-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: white;
      font-size: 13px;

      > div {
         padding: 4px 4px 4px 0;
      }

      .mp-filename {
         // flex: 2 0 60%;
         // overflow: hidden;
         // text-overflow: ellipsis;
         width: 242px;
         div {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
         }
      }
   }

   .btn-mp-audio-play {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-image: url('./../../assets/img/media/bttn-play-circle.svg'); 
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 30px 30px;
      background-color: transparent;
      font-size: 24px;
      font-size: 1.5rem;
      &.active {
         border-radius: 50%;
         background-image: url('./../../assets/img/media/bttn-pause.svg'); 
         background-size: 12px 12px;
         background-color: #1875f0;
         outline: none;
      }
      &:focus {
         outline: none;
      }
   }
   

   .meta-data-container {
      top: 1%;
      left: 32%;
      // box-shadow: 6px 8px 20px rgba(0,0,0,0.8);
   }
}
</style>
